import React, { useState } from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import Swal from "sweetalert2";
import WarningIcon from "@material-ui/icons/Warning"; // Corrigindo importação
import Api from "../../providers/Api/Api";
import {CircularProgress} from "@material-ui/core";
export default function TextFieldCNPJ(props) {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  React.useEffect(()=>{
      props.setError(error);
  }, [error])

  // Função para formatar o CNPJ
  const formatCNPJ = (value) => {
    return value
      .replace(/\D/g, "") // Remove tudo que não for número
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .slice(0, 18); // Garante o tamanho correto
  };

  // Função para validar CNPJ
  const validateCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/\D/g, ""); // Remove formatação

    if (cnpj.length !== 14) return false;

    // Elimina CNPJs inválidos conhecidos
    if (/^(\d)\1+$/.test(cnpj)) return false;

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return resultado === parseInt(digitos.charAt(1));
  };

  const handleChange = (event) => {
    const newValue = formatCNPJ(event.target.value);
    const isValid = newValue.length === 18 && validateCNPJ(newValue);
    
    setError(!isValid); // Define o erro

    if (props.onChange) {
      props.onChange({
        ...event,
        target: { ...event.target, value: newValue },
      });
    }
  };
  const getDataCNPJ = () =>{
    setLoading(true)
    Api.get('https://api.opencnpj.org/'+props.value).then(response=>{
      if(response.status === 200){
           props.setDataEmpresa(response.data)
        
      }else{
        props.setDataEmpresa( [])
      }
      setTimeout(() => {
        setLoading(false)
      }, 500);
    }).catch(error=>{
        props.setDataEmpresa( [])
        setTimeout(() => {
        setLoading(false)
      }, 500);
    })
  }

  return (
    <TextField
      {...props}
      error={error}
      helperText={error ? "CNPJ inválido" : ""}
      onChange={handleChange}
      value={props.value || ""}
      InputProps={{
        endAdornment: error ? (
          <InputAdornment position="end">
            <WarningIcon color="error" />
          </InputAdornment>
        ) : loading ? <CircularProgress size={20} color="secondary" /> : null,
      }}
      onBlur={() => {
        if (error) {
          props.resetEmpresaCNPJ()
          Swal.fire({
            title: "Corporate Web",
            text: "O CNPJ informado é inválido! Verifique!",
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }}
      onKeyDown={(e) => {
        if (e.keyCode === 13) {
          props.setDataEmpresa(getDataCNPJ())
          
          
        }
      }}
    />
  );
}
